import * as React from "react";
import {
  Show,
  SimpleShowLayout,
  ShowProps,
  FunctionField,
  TextField,
  DateField,
  BooleanField,
  NumberField 
} from "react-admin";

export const DiscountShow = (props: ShowProps): React.ReactElement => {
  return (
    <Show {...props}>
      <SimpleShowLayout>
        <TextField source="code" label="کد تخفیف" />
        <NumberField source="count" label="تعداد" />
        <DateField source="createdAt" label="تاریخ ایجاد" />
        <TextField source="createdBy" label="ایجاد کننده" />
        <TextField source="description" label="توضیحات" />
        <TextField source="discountType" label="نوع تخفیف" />
        <BooleanField source="isEnabled" label="فعال" />
        <TextField source="name" label="نام" />
        <DateField source="updatedAt" label="تاریخ بروزرسانی" />
        <TextField source="updatedBy" label="بروزرسانی کننده" />
        <DateField source="expiryDate" label="تاریخ انقضا" />
        <DateField source="startDate" label="تاریخ شروع" />
        <NumberField source="countPerUser" label="تعداد مجاز برای هر کاربر" />
        <FunctionField
          label="اطلاعات متا"
          render={(record: any) => JSON.stringify(record.meta)}
        />
        <FunctionField
          label="محصولات"
          render={(record: any) => JSON.stringify(record.products)}
        />
        <FunctionField
          label="برچسب‌ها"
          source="tags"
          render={(record: any) => JSON.stringify(record.tags)}
        /> 
        {/* <NumberField source="serialNumber" label="شماره سریال" />  */}
        <NumberField source="usedDiscountsCount" label="دفعات استفاده" /> 
      </SimpleShowLayout>
    </Show>
  );
};
